import { render, staticRenderFns } from "./APIObjectDataEditField.vue?vue&type=template&id=39760814&scoped=true"
import script from "./APIObjectDataEditField.vue?vue&type=script&lang=js"
export * from "./APIObjectDataEditField.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39760814",
  null
  
)

export default component.exports